const CURRENCY = '€';
const EMPTY = '0,00 €';

export default function ($filter) {
  return {
    restrict: 'A',
    require: 'ngModel',

    link: function (scope, elem, attrs, ngModel) {

      // Focus event

      elem.on('focus', onFocus);

      function onFocus() {
        const currentVal = elem.val();

        if (currentVal === EMPTY) {
          return elem.val('');
        }

        const newVal = currentVal.replace(/\./g, '').replace('€', '');
        elem.val(newVal);
      }

      // Blur and paste events

      elem.on('blur paste', () => setViewValue());

      function setViewValue(previousVal) {
        let val = elem.val();

        if (previousVal) {
          val = previousVal.toString();
        }

        val = val.trim();
        val = removeValuesAfterCurrency(val);
        val = getNumberFromVal(val);
        val = $filter('currency')(val);
        elem.val(val);
        return val;
      }

      // Formatter

      ngModel.$formatters.push(formatter);

      function formatter(val) {
        if (val > 0) {
          return setViewValue(val);
        }

        return attrs.placeholder ? '' : setViewValue(val);
      }

      // Parser

      ngModel.$parsers.push(parser);

      function parser(val) {
        val = val.trim();
        val = removeValuesAfterCurrency(val);
        val = getNumberFromVal(val);
        val = parseFloat(val, 10);
        val = isNaN(val) ? 0 : val;
        return val;
      }

      // Helpers

      function getNumberFromVal(val) {
        return removeLetters(val)
          .replace(/€/g, '')
          .replace(/\./g, '')
          .replace(/\,/, '.')
          .replace(/,/g, '');
      }

      function removeLetters(val) {
        const preserve = /[^\d|\-+|,|\.|+]/g;
        return val.replace(preserve, '');
      }

      function removeValuesAfterCurrency(val) {
        if (val.charAt(val.lenght - 1) !== CURRENCY) {
          return val.split(CURRENCY)[0];
        } else {
          return val;
        }
      }
    },
  };
}



// WEBPACK FOOTER //
// ./client/app/common/directives/currencyInput.js